import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetCoupon } from "../redux/slices/GetCouponSlice";
import { useNavigate } from "react-router-dom";
import Footer from "../Fotter";
import copy from "copy-to-clipboard";
import { AiOutlineArrowLeft } from "react-icons/ai";

const Coupons = () => {
  const dispatch = useDispatch();
  const { GetCouponData } = useSelector((state) => state?.getCoupon);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetCoupon());
  }, [dispatch]);

  const copyCode = (code) => {
    alert(`Coupon code copied: ${code}`);
    copy(code);
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const _handleClickCoupon = (coupon) => {
    if (coupon?.applicableCategories?.length > 0) {
      const name = coupon?.applicableCategories[0];
      navigate(`/product-category/${generateSlug(name.name)}/${name._id}`, {
        state: { name },
      });
    }
    if (coupon?.applicableProducts?.length > 0) {
      const name = coupon?.applicableProducts[0];
      // navigate("/ProductDetails", { state: { name } });
      navigate(
        `/shop/${coupon?.category ? generateSlug(coupon?.category) : "-"}/${coupon?.subcategory ? generateSlug(coupon?.subcategory) : "-"
        }/${generateSlug(coupon?.title)}}
        )}`,
        {
          state: { name },
        }
      );
    }
  };

  return (
    <div className="flex flex-col min-h-screen ">
      <div className="flex-grow">
        <div className="flex mx-auto  items-center  w-[90%]  sm:mt-5 mt-2 justify-between ">
          <button
            onClick={() => navigate(-1)}
            className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center "
          >
            <AiOutlineArrowLeft className="text-lg mr-1" />
          </button>
          <h1 className="text-lg  font-bold   text-center">
            Exclusive Coupons
          </h1>
          <h1></h1>
        </div>
        <div className="p-6 sm:p-4">
          <div className="container mx-auto max-w-7xl">
            <div className="">
              {GetCouponData?.coupons && GetCouponData.coupons.length > 0 ? (
                GetCouponData.coupons.map((coupon) => (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 md:gap-6 gap-2">
                    <div
                      key={coupon._id}
                      className="relative bg-white rounded-xl shadow-lg overflow-hidden transition sm:transform sm:hover:scale-105 w-full"
                    >
                      {/* Discount Badge */}
                      <div className="absolute top-0 right-0 bg-red-500 text-white px-3 py-1 text-sm font-semibold rounded-bl-xl">
                        {coupon.discount}
                        {coupon.discountType === "percentage" ? "%" : ""} OFF
                      </div>
                      <div className="p-4">
                        <div
                          onClick={() => _handleClickCoupon(coupon)}
                          className="flex items-center"
                        >
                          {coupon.image && coupon.image[0] && (
                            <img
                              src={coupon.image[0]}
                              alt={coupon.Title}
                              className="w-20 h-20 object-cover rounded-lg mr-4"
                            />
                          )}
                          <div>
                            <h3 className="text-xl font-semibold text-gray-800 mt-6 line-clamp-1 mb-2">
                              {coupon.Title}
                            </h3>
                            <p className="text-gray-600 line-clamp-2">
                              {coupon.description}
                            </p>
                          </div>
                        </div>
                        <div className="mt-4">
                          <div className="flex items-center justify-between bg-gray-100 border border-gray-300 rounded-lg">
                            <span className="text-lg font-mono text-gray-800 w-[50%] truncate px-2 py-1 rounded-l-md">
                              {coupon.code}
                            </span>
                            <button
                              onClick={() => copyCode(coupon.code)}
                              className="w-[45%] bg-blue-100 hover:bg-blue-400 text-black font-semibold py-2 px-1 rounded-lg transition duration-300 ease-in-out transform"
                            >
                              Copy Code
                            </button>
                          </div>

                          {(coupon.applicableCategories.length > 0 ||
                            coupon.applicableBrands.length > 0 ||
                            coupon.applicableProducts.length > 0) && (
                              <div className="flex flex-nowrap mt-2 space-x-2">
                                <p className="text-sm font-bold text-black whitespace-nowrap">
                                  Applicable On :
                                </p>
                                {coupon?.applicableCategories?.length > 0 && (
                                  <p className="text-sm text-black line-clamp-2">
                                    {"Category"} (
                                    {coupon?.applicableCategories[0]?.name})
                                  </p>
                                )}
                                {coupon?.applicableBrands?.length > 0 && (
                                  <p className="text-sm text-black line-clamp-2 ">
                                    {"Brand"} ({coupon?.applicableBrands[0]?.name})
                                  </p>
                                )}
                                {coupon?.applicableProducts?.length > 0 && (
                                  <p className="text-sm text-black line-clamp-2">
                                    {"Products"} (
                                    {coupon?.applicableProducts[0]?.title})
                                  </p>
                                )}
                              </div>
                            )}
                          <div className="flex  mt-2 space-x-2">
                            <p className="text-sm font-bold text-black">T&C:</p>
                            <p className="text-sm text-black line-clamp-2">
                              {coupon.TnC}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="items-center justify-center mt-20">
                  <p className=" text-black text-center font-bold ">Coupon not found</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Coupons;
